"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _migrationsBlob = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/migrations-blob.jpg"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _colors = require("HubStyleTokens/colors");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _CodeSplitEnvWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/CodeSplitEnvWrapper"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _SkeletonLoadWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/loading/SkeletonLoadWrapper"));

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _reactRedux = require("react-redux");

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  &:not(:empty) {\n    margin-top: 32px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-row-gap: 8px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  @media (max-width: 767px) {\n    display: none;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    font-size: 30px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-weight: bold;\n  line-height: 44px;\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-transform: uppercase;\n  font-weight: 500;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Title = (0, _styledComponents.default)(_Small.default).withConfig({
  displayName: "MigrateYourSite__Title",
  componentId: "sc-1vobd6v-0"
})(_templateObject());

var Subtitle = _styledComponents.default.h1.withConfig({
  displayName: "MigrateYourSite__Subtitle",
  componentId: "sc-1vobd6v-1"
})(_templateObject2(), _responsiveBreakpoints.default.phone(_templateObject3()));

var MigrationImageWrapper = (0, _styledComponents.default)(_UIGridItem.default).withConfig({
  displayName: "MigrateYourSite__MigrationImageWrapper",
  componentId: "sc-1vobd6v-2"
})(_templateObject4());

var FeaturesGrid = _styledComponents.default.div.withConfig({
  displayName: "MigrateYourSite__FeaturesGrid",
  componentId: "sc-1vobd6v-3"
})(_templateObject5());

var CtaWrapper = _styledComponents.default.div.withConfig({
  displayName: "MigrateYourSite__CtaWrapper",
  componentId: "sc-1vobd6v-4"
})(_templateObject6());

var CheckedItem = function CheckedItem(_ref) {
  var message = _ref.message;
  return _react.default.createElement("div", {
    className: "flex-row justify-left align-center"
  }, _react.default.createElement(_UIIcon.default, {
    className: "m-right-3",
    color: _colors.OBSIDIAN,
    name: "success"
  }), _react.default.createElement("div", null, _react.default.createElement(_FormattedMessage.default, {
    message: message
  })));
};

var MigrateYourSite = function MigrateYourSite() {
  var hasPricingAndPurchasingSucceeded = (0, _reactRedux.useSelector)(_LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector);
  return _react.default.createElement(_UIGrid.default, null, _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 12,
      md: 7
    },
    className: "flex-column justify-center"
  }, _react.default.createElement(Title, {
    use: "help"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "websiteMigration.title"
  })), _react.default.createElement(Subtitle, null, _react.default.createElement(_FormattedMessage.default, {
    message: "websiteMigration.subtitle"
  })), _react.default.createElement("div", {
    className: "m-bottom-4"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "websiteMigration.description"
  })), _react.default.createElement(FeaturesGrid, null, _react.default.createElement(CheckedItem, {
    message: "websiteMigration.templateSetup"
  }), _react.default.createElement(CheckedItem, {
    message: "websiteMigration.websiteMigration"
  }), _react.default.createElement(CheckedItem, {
    message: "websiteMigration.blogMigration"
  }), _react.default.createElement(CheckedItem, {
    message: "websiteMigration.emailTemplateRebuilding"
  })), _react.default.createElement(CtaWrapper, null, _react.default.createElement(_SkeletonLoadWrapper.default, {
    height: 40,
    width: 127,
    isLoading: !hasPricingAndPurchasingSucceeded
  }, _react.default.createElement(_CodeSplitEnvWrapper.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import(
      /* webpackChunkName: "authed-chunk" */
      "pricing-pages-unified-ui/components/common/HubAuthedTtsButton");
    },
    publicComponentLoader: function publicComponentLoader() {
      return import(
      /* webpackChunkName: "public-chunk" */
      "pricing-pages-unified-ui/components/public-only/PublicPurchaseMotionButton");
    },
    authedComponentProps: {
      hub: _Hubs.default.HUB_CMS,
      location: _Tracking.MIGRATE_YOUR_SITE
    },
    publicComponentProps: {
      sourceId: 'pricing-middle',
      merchandiseId: _MerchandiseIds.SERVICE_FIRST_TIME_FULL_MIGRATION
    }
  })))), _react.default.createElement(MigrationImageWrapper, {
    size: {
      xs: 0,
      md: 5
    }
  }, _react.default.createElement(_UIImage.default, {
    src: _migrationsBlob.default
  })));
};

var _default = MigrateYourSite;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/cms-hub-page/MigrateYourSite.js
// module id = 872
// module chunks = 5 6